<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.67 30.14" :class="['size', $attrs.class]">
    <path fill="currentColor" d="M3.86 15.07L16.2 2.73c.62-.62.62-1.64 0-2.26-.62-.62-1.64-.62-2.26 0L.47 13.94c-.62.62-.62 1.64 0 2.26l13.47 13.47c.31.31.72.47 1.13.47a1.598 1.598 0 001.13-2.73L3.86 15.07z"/>
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  inheritAttrs: false
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg{
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
